import { Box, Stack, Typography } from "@mui/material"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { formatRuleSummary, formatActionLabel } from "../rule-sets/format-rule-summary"
import { DisabledChip } from "./disabled-chip"

export function RulesPanelRuleExplanation({ item }) {
    const rule = item
    const { conditionFields = [] } = useBoundContext()
    const enabled = rule.enabled !== false
    const opacity = enabled ? 1 : 0.5

    if (isRuleSetReference(rule)) {
        const referenceLabel = rule.ruleSetName || rule.ruleSetId || "Rule set reference"

        return (
            <Box data-cy="rules-panel-rule-explanation" sx={{ py: 1, px: 1.5, opacity }}>
                <Stack direction="row" alignItems="center" spacing={1}>
                    <Stack spacing={0.25} sx={{ flex: 1, minWidth: 0 }}>
                        <Typography variant="body2" fontWeight={600} sx={{ textDecoration: getTextDecoration() }}>
                            {referenceLabel}
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                            Included rule set
                        </Typography>
                    </Stack>
                    <DisabledChip enabled={enabled} />
                </Stack>
            </Box>
        )
    }

    const ruleName = rule.name || "Unnamed rule"
    const summary = formatRuleSummary(rule, conditionFields)
    const actionLabel = formatActionLabel(rule.action)
    const actionColor = rule.action?.type === "exclude" ? "error.main" : "primary.main"

    return (
        <Box data-cy="rules-panel-rule-explanation" sx={{ py: 1, px: 1.5, opacity }}>
            <Stack direction="row" alignItems="center" spacing={1}>
                <Stack spacing={0.25} sx={{ flex: 1, minWidth: 0 }}>
                    <Typography variant="body2" fontWeight={600} sx={{ textDecoration: getTextDecoration() }}>
                        {ruleName}
                    </Typography>
                    <Typography variant="caption" color="text.secondary" sx={{ textDecoration: getTextDecoration() }}>
                        <Box component="span">If </Box>
                        <Box component="span">{summary}</Box>{" "}
                        <Box component="span" sx={{ color: actionColor, fontWeight: 600 }}>
                            {actionLabel}
                        </Box>
                    </Typography>
                </Stack>
                <DisabledChip enabled={enabled} />
            </Stack>
        </Box>
    )

    function getTextDecoration() {
        if (enabled) return "none"
        return "line-through"
    }
}

function isRuleSetReference(rule) {
    return rule?.type === "ruleSetReference"
}
